import React, {PureComponent} from "react";
import Input from "./Input";
import SelectInput from "./SelectInput";

export default class ConsumptionBlock extends PureComponent {
    constructor() {
        super(...arguments);

        this.operator_grms = this.props.operator_grms;
        this.building_types = this.props.building_types;

        this.handleChangeEic = this.handleChangeEic.bind(this);
        this.handleBlurEic = this.handleBlurEic.bind(this);
    }

    handleChangeEic(attr, value) {
        if (!value.match(/^56X[a-zA-Z0-9]{0,13}$/)) {
            this.props.updateErrors(attr, 'Невірний формат EIC-кода')
        } else {
            this.props.updateErrors(attr, null);
            this.props.onChange(attr, value.toUpperCase());
        }
    }

    handleBlurEic(attr, value) {
        if (!value.match(/^56X[a-zA-Z][0-4,9][0-9][a-zA-Z][0-9]{8}[a-zA-Z0-9]$/) || value.length === 0) {
            this.props.updateErrors(attr, 'Невірний формат EIC-кода');
        } else {
            this.props.updateErrors(attr, null);
        }
    }



    render() {
        const {eic, operator_grm_id, building_type, errors} = this.props;

        return (
            <div>
                <h2 className="mb-3">{window.translates.join_form.consumption_header}</h2>
                <div className="row">
                    <div className="col-sm-6">
                        <Input attr={'eic'} value={eic} label={window.translates.join_form.labels.eic}
                               onChange={this.handleChangeEic}
                               onBlur={this.handleBlurEic}
                               error={errors.eic} required={true}
                        />
                    </div>
                    <div className="col-sm-6">
                        <SelectInput
                            label={window.translates.join_form.labels.operator_grm}
                            attribute={'operator_grm_id'}
                            value={operator_grm_id}
                            options={this.operator_grms}
                            onChange={this.props.onChange}
                            required={true}
                            error={errors.operator_grm_id}
                        />
                    </div>
                    <div className="col-sm-6">
                        <SelectInput
                            label={window.translates.join_form.labels.building_type}
                            attribute={'building_type'}
                            value={building_type}
                            options={this.building_types}
                            onChange={this.props.onChange}
                            required={true}
                            error={errors.building_type}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
